export default "__VITE_ASSET__DkBEH88A__"